import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  icon: {
    fontSize: '48px !important'
  }
}))
